import { useNavigate } from "react-router-dom";
import { AlertTriangle, Shield } from "lucide-react";
import { Button } from "@/components/ui/button";

export function KycBookingNotice({ message, compact = false, testId = "booking-kyc-notice" }) {
  const navigate = useNavigate();

  return (
    <div
      className={`border border-amber-200 bg-amber-50 text-amber-900 ${compact ? "rounded-lg p-3" : "rounded-2xl p-4 sm:p-5"}`}
      data-testid={testId}
    >
      <div className={`flex ${compact ? "items-start gap-3" : "flex-col gap-4 sm:flex-row sm:items-center sm:justify-between"}`}>
        <div className="flex items-start gap-3 min-w-0">
          <div className="w-10 h-10 rounded-full bg-amber-100 flex items-center justify-center shrink-0">
            <Shield className="w-5 h-5 text-amber-700" />
          </div>
          <div className="min-w-0">
            <p className="font-heading text-sm uppercase tracking-wide flex items-center gap-2">
              <AlertTriangle className="w-4 h-4" />
              KYC approval required
            </p>
            <p className="text-sm mt-1">{message}</p>
          </div>
        </div>

        <Button
          type="button"
          onClick={() => navigate("/profile")}
          className="bg-court-orange hover:bg-court-orange-hover text-white rounded-full font-heading uppercase text-xs"
          data-testid={`${testId}-cta`}
        >
          Complete KYC in Profile
        </Button>
      </div>
    </div>
  );
}